import { ReactComponent as Avatar1 } from './avatar_1.svg';
import { ReactComponent as Avatar2 } from './avatar_2.svg';
import { ReactComponent as Avatar3 } from './avatar_3.svg';
import { ReactComponent as Avatar4 } from './avatar_4.svg';
import { ReactComponent as Avatar5 } from './avatar_5.svg';
import { ReactComponent as Avatar6 } from './avatar_6.svg';
import { ReactComponent as Avatar7 } from './avatar_7.svg';
import { ReactComponent as Avatar8 } from './avatar_8.svg';
import { ReactComponent as Avatar9 } from './avatar_9.svg';
import { ReactComponent as Avatar10 } from './avatar_10.svg';
import { ReactComponent as Avatar11 } from './avatar_11.svg';
import { ReactComponent as Avatar12 } from './avatar_12.svg';

export const Avatars = {
  Avatar1: Avatar1,
  Avatar2: Avatar2,
  Avatar3: Avatar3,
  Avatar4: Avatar4,
  Avatar5: Avatar5,
  Avatar6: Avatar6,
  Avatar7: Avatar7,
  Avatar8: Avatar8,
  Avatar9: Avatar9,
  Avatar10: Avatar10,
  Avatar11: Avatar11,
  Avatar12: Avatar12,
};
